import Container from "@components/layout/Container";

const IconChisel = () => (
	<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
		<path d="M22 4l6 6-12 12-8 2 2-8z" />
		<path d="M16 10l6 6" />
		<path d="M4 28l4-4" />
	</svg>
);

const IconClock = () => (
	<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
		<circle cx="16" cy="16" r="12" />
		<path d="M16 9v7l4 3" />
	</svg>
);

const IconSparkle = () => (
	<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
		<path d="M16 3l3 10 10 3-10 3-3 10-3-10L3 16l10-3z" />
	</svg>
);

const IconDiamond = () => (
	<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round">
		<path d="M6 12l10-8 10 8-10 16z" />
		<path d="M6 12h20" />
		<path d="M12 12l4 16" />
		<path d="M20 12l-4 16" />
	</svg>
);

const features = [
	{icon: <IconChisel />, title: "Ручна різьба", desc: "Кожен орнамент і напис — ручна робота досвідчених різьбярів"},
	{icon: <IconClock />, title: "Вчасно", desc: "Дотримуємось терміну і тримаємо вас в курсі кожного етапу"},
	{icon: <IconSparkle />, title: "Ексклюзивний дизайн", desc: "Жодного шаблону — тільки індивідуальний проєкт під ваш запит"},
	{icon: <IconDiamond />, title: "Якісний камінь", desc: "Використовуємо тільки сертифікований камінь з перевірених кар'єрів"},
];

export default function Philosophy() {
	return (
		<section className="philosophy">
			<Container>
				<div className="philosophy-grid">
					<div className="philosophy-left">
						<span className="eyebrow eyebrow--gold philosophy-label">
							Наша філософія
						</span>
						<h2 className="philosophy-title">
							Кожен камінь —{" "}
							<span style={{color: "rgba(102, 136, 170, 1)", fontStyle: "italic"}}>окрема історія</span>
						</h2>
						<p className="philosophy-body">
							Ми віримо, що пам&apos;ятник — це не просто виріб із каменю. Це
							місце, де живе пам&apos;ять. Місце, куди приходять, щоб
							поговорити з тими, кого більше немає поруч.
						</p>
						<p className="philosophy-body">
							Тому ми підходимо до кожного замовлення з терпінням, повагою та
							увагою до найменших деталей — адже кожна деталь має значення для
							тих, хто залишився.
						</p>
					</div>

					<div className="philosophy-cards">
						{features.map((f) => (
							<div key={f.title} className="philosophy-card">
								<span className="philosophy-card-icon">{f.icon}</span>
								<h4 className="philosophy-card-title">{f.title}</h4>
								<p className="philosophy-card-desc">{f.desc}</p>
							</div>
						))}
					</div>
				</div>
			</Container>
		</section>
	);
}
